import { render } from "./addGoods.vue?vue&type=template&id=53805ab8&scoped=true"
import script from "./addGoods.vue?vue&type=script&lang=js"
export * from "./addGoods.vue?vue&type=script&lang=js"

import "./addGoods.vue?vue&type=style&index=0&id=53805ab8&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53805ab8"]])

export default __exports__